import styled from "styled-components"
import {devices} from '../../../components/MediaQuerys/BreakpointsAndDevices'


// Double Container
// const DoubleContainerComponent = styled.div`
//     display: grid;
//     justify-content: end;
//     align-items: center;
//     margin: 0 auto;
//     grid-template-columns: 1fr 1fr;
//     row-gap: 20px;
//     column-gap: 15px;
//     width: 100%;
// `
// export const DoubleContainer = (props)=>{
//     return(
//         <DoubleContainerComponent>
//             {props.children}
//         </DoubleContainerComponent>
//     )
// }
// Single Container
const SingleContainerComponent = styled.div`
    display: grid;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    /* grid-template-columns: 1fr 1fr; */
    row-gap: 20px;
    column-gap: 15px;
    width: 100%;
    /* background-color: rebeccapurple; */
    @media only screen and ${devices.mobileS} {
        width: 320px;
        
    }
    @media only screen and ${devices.mobileM} {
        width: 375px;
        
    }
    @media only screen and ${devices.tablet} {
        min-width: 768px;
    }
    @media only screen and ${devices.laptop}{
        width: 1024px;

    }
    @media only screen and ${devices.laptopL}{
        width: 1440px;

    }
`
export const SingleContainer = (props)=>{
    return(
        <SingleContainerComponent>
            {props.children}
        </SingleContainerComponent>
    )
}